import { useSelector } from "react-redux";
import { BillingCSVDownloadForm } from "../../../components/BillingCSVDownloadForm";
import { BillingCSVDownloadRequest } from "../../../gateways/cms/billingData";
//import { billingDataDownload } from "../../../gateways/cms/billingDataDownload";
//import { useDownloadBillingCSVQuery } from "../../../gateways/cms/billingRuleApi";
import MainLayout from "../../../layouts/MainLayout";
import { RootState } from "../../../store";
import { styled } from "@mui/system";
import axios from 'axios';
import Config from "../../../Config";

// style
const PageTitle = styled("h1")`
    /* display: flex;
    justify-content: flex-start; */
    padding: 24px;
    // margin-bottom: 16px;
    font-size: 24px;
    font-weight: normal;
    margin: 0 40px 0 0;
`;
const PageContent = styled("section")`
    padding: 0 40px 24px;
`;

export function BillingCSVPage() {
    /*** 請求元CSVデータダウンロード ***/
    const token = useSelector((state: RootState) => state.auth.token);
    // ファイル名取得
    const getFileName = () => {
        const today = new Date();
        //const formatted = today.toLocaleDateString("ja-JP", {
        //                        year: "numeric", month: "2-digit", day: "2-digit"})
        //                        .split("/").join("");
        const year = today.getFullYear().toString().slice(-2);
        const month = (today.getMonth() + 1).toString().padStart(2, '0');
        const day = today.getDate().toString().padStart(2, '0');
        const hour = today.getHours().toString().padStart(2, '0');
        const minute = today.getMinutes().toString().padStart(2, '0');
        const second = today.getSeconds().toString().padStart(2, '0');
        //const dateTime = formatted + "-" + hour + minute + second;
        const dateTime = year + month + day + "-" + hour + minute + second; 
        const fileName = "BillingData_" + dateTime + ".csv";
        return fileName;
    }

    /*** CSVダウンロード ***/
    const handleDownloadBillingCSV = async(request: BillingCSVDownloadRequest) => {
        // 請求元CSVデータ取得API実行
        const instance = axios.create({
            baseURL: Config.baseEndpoint,
            headers: {
                Accept: "application/json, application/octet-stream",
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        });

        // CSVデータ取得
        const response = await instance.post(`billingCSV`, {organizationIds: request.organizationIds});
        const csvData = String(response.data);
        //const csvDatas = Array(response.data);
        const fileName = getFileName();
        //const bom  = new Uint8Array([0xEF, 0xBB, 0xBF]);

        // SJISにエンコード
        const encoding = require('encoding-japanese');
        const sjisArray = encoding.convert(csvData, {
            to: 'SJIS',
            from: 'UNICODE',
            type: 'arraybuffer'
        });
        // CSVファイル作成
        const uint8Array = new Uint8Array(sjisArray);
        const blob = new Blob([uint8Array], { type: 'text/plain;charset=shift_jis' });

        // CSVファイルダウンロード
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    }

    return (
        <MainLayout title="請求元データCSVダウンロード">
            <PageTitle>請求元データCSVダウンロード</PageTitle>
            <PageContent>
                <BillingCSVDownloadForm onSubmit={handleDownloadBillingCSV} />
            </PageContent>
        </MainLayout>
    );
}
